module.exports = __webpack_public_path__ + "img/rank-ribbon.2ab275e9.svg";